import { render, staticRenderFns } from "./ProposalReviewDashboard.vue?vue&type=template&id=4df9bb68"
import script from "./ProposalReviewDashboard.vue?vue&type=script&lang=js"
export * from "./ProposalReviewDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports